const ITEMS = [
  "Senior Data & Cloud",
  "USA Time Zone",
  "Boutique Nearshore",
  "US Projects Only",
  "7+ Years Senior",
  "Specialists, Not Generalists",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden bg-brand-teal py-3.5" data-testid="editorial-marquee" aria-hidden="true">
      <div className="flex w-max animate-marquee items-center gap-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="font-cond text-xs font-semibold uppercase tracking-[0.3em] text-white/85">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-brand-orange" />
          </span>
        ))}
      </div>
    </div>
  );
}
